import React, { Component } from 'react';
import QbmModal from '../../../../modals/common/QbmModal';
import { Field, reduxForm } from 'redux-form'
import InputField from '../../../../helpers/Fields/InputField';
import PropTypes from 'prop-types'
import { required, email, numericality } from 'redux-form-validators'
import CheckboxField from '../../../../helpers/Fields/CheckboxField';

class FormModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  render() {
    const {formatMessage} = this.context;

    const {handleClose, isOpen, handleSubmit, initialValues} = this.props;
    return (
      <QbmModal
        show={isOpen}
        title={initialValues.id ? formatMessage('FormUpdateDiscount') : formatMessage('FormNewDiscount')}
        onClose={handleClose}
      >
        <form className="create-dialog-form" onSubmit={handleSubmit(this.props.save)}>
          <Field
            name="title"
            label={formatMessage('titleDiscount')}
            component={InputField}
            validate={[required()]}
          />
          <Field
            name="published"
            label={formatMessage('publishedDiscount')}
            component={CheckboxField}
            type="int"
          />
          <Field
            name="promo_code"
            label={formatMessage('promo_codeDiscount')}
            component={InputField}
            validate={[required()]}
          />
           <Field
            name="percentage"
            label={formatMessage('percentageDiscount')}
            component={InputField}
            validate={[required(), numericality({int: true, '>': 0, '<': 100})]}
          />
          <Field
            name="number_of_uses"
            label={formatMessage('number_of_usesDiscount')}
            component={InputField}
            validate={[required(), numericality({int: true})]}
          />
          <div className="actions">
            <button
                className="btn btn-primary"
                type="submit"
            >{formatMessage('btnDiscountSave')}</button>
          </div>
        </form>
      </QbmModal>
    );
  }
}

export default reduxForm({
  form: 'discount_form' 
})(FormModal)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Discounts/components/FormModal/index.jsx